export const SNACKBAR_SET = 'SNACKBAR_SET';

export function setSnackbar(text, timeout, open = false) {
	return {
		type: SNACKBAR_SET,
		text,
		timeout,
		open
	};
}